module.exports = __webpack_public_path__ + "media/images/countrysquared/mk-2146f3931e25354976033058195868d0.svg";